<template>

  <div>
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <a class="navbar-brand"
        href="#">| XPTO</a>
      <div class="my-2 my-lg-0">
        <a class="btn btn-outline-secondary mr-2"
          href="/profile">Perfil</a>
        <a class="btn btn-outline-secondary pl-2"
          href="/logout">Sair</a>
      </div>
    </nav>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    name: "MainNav",
    computed: {
      ...mapGetters(["isAuthenticated"]),
    },
  };
</script>
<style scoped>
  .dropdown-toggle {
    outline: 0;
  }

  .btn-toggle {
    font-family: "Georama";
    padding: .25rem .5rem;
    font-weight: 600;
    color: rgba(0, 0, 0, .65);
    background-color: transparent;
    width: 100%;
  }

  .btn-toggle:hover,
  .btn-toggle:focus {
    color: rgba(0, 0, 0, .85);
    background-color: #efefef;
  }

  .btn-toggle::before {
    width: 1.25em;
    line-height: 0;
    content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    transition: transform .35s ease;
    transform-origin: .5em 50%;
  }

  .btn-toggle[aria-expanded="true"] {
    color: rgba(0, 0, 0, .85);
  }

  .btn-toggle[aria-expanded="true"]::before {
    transform: rotate(90deg);
  }

  .btn-toggle-nav a {
    font-family: "Georama";
    padding: 6px;
    margin-top: .125rem;
    margin-left: 1.25rem;
    font-size: 14px;
  }

  .btn-toggle-nav a:hover,
  .btn-toggle-nav a:focus {
    background-color: #d2f4ea;
  }
</style>